// import {DialogType, ZdsActivityType} from "@/config";
import { PageContext, reloadUrl } from '@zto/zpage-runtime'
// import {ZdsOrderDeliveryType} from "@/pages/orderlist/config";
import { DialogType } from '@/config/enums'
import { ElMessage } from 'element-plus'
import XLSX from 'xlsx'
import dayjs from 'dayjs'

const formItemStyleAttrs = Object.freeze({ style: 'width: 400px;' })

/**
 * 判断分账规则的时间状态
 * @param effectiveTime 分账开始时间
 * @param expireTime 分账结束时间
 * @returns 'NOT_STARTED' | 'IN_PROGRESS' | 'APPROACHING_END' | 'ENDED'
 */
const getTimeStatus = (effectiveTime: any, expireTime: any) => {
  const now = Date.now()
  const startTime = effectiveTime ? new Date(effectiveTime).getTime() : 0
  const endTime = expireTime ? new Date(expireTime).getTime() : 0

  // 定义30天的毫秒数
  const THIRTY_DAYS_IN_MS = 30 * 24 * 60 * 60 * 1000

  if (startTime && now < startTime) {
    return 'NOT_STARTED' // 未开始
  } else if (endTime && now > endTime) {
    return 'ENDED' // 已结束
  } else if (endTime && endTime - now <= THIRTY_DAYS_IN_MS) {
    return 'APPROACHING_END' // 即将到期（30天内）
  } else {
    return 'IN_PROGRESS' // 进行中
  }
}

function validateFormat(effectTime: string, expireTime: string, isEdit: boolean, originEffectiveTime: string): boolean {
  const timeStatus = getTimeStatus(originEffectiveTime, expireTime)

  const currentTime = new Date()
  const selectedTime = new Date(effectTime)
  const _expireTime = new Date(expireTime)

  // 计算10分钟后的时间
  const minTime = new Date(currentTime.getTime() + 10 * 60 * 1000)
  // 计算30天后的时间
  const maxTime = new Date(currentTime.getTime() + 30 * 24 * 60 * 60 * 1000)
  // 判断时间范围
  if (selectedTime < minTime) {
    if (isEdit && (timeStatus === 'IN_PROGRESS' || timeStatus === 'APPROACHING_END')) {
    } else {
      // 使用你项目中的提示组件，这里用示例代码
      ElMessage.success('分账开始时间必须晚于当前时间10分钟')
      // 或者重置时间
      return false
    }
  } else if (selectedTime > maxTime) {
    if ((isEdit && timeStatus === 'IN_PROGRESS') || timeStatus === 'APPROACHING_END') {
    } else {
      ElMessage.success('分账开始时间不能晚于当前时间30天')
      // 或者重置时间
      return false
    }
  }

  if (expireTime) {
    // 计算730天后的时间
    const expireMaxTime = new Date(selectedTime.getTime() + 730 * 24 * 60 * 60 * 1000)
    if (selectedTime >= _expireTime) {
      ElMessage.success('分账结束时间必须晚于分账开始时间')
      return false
    }
    if (_expireTime > expireMaxTime) {
      ElMessage.success('分账结束时间不能晚于分账开始时间+730天')
      // 或者重置时间
      return false
    }
  }

  return true
}

/**
 * 新增编辑对话框
 * @returns
 */
export function addEditDialog(dialogType: DialogType = DialogType.ADD) {
  const isAdd = dialogType === DialogType.ADD
  const isEdit = dialogType === DialogType.EDIT
  const isView = dialogType === DialogType.VIEW

  return {
    width: 800,
    labelWidth: 160,
    title: isEdit ? '编辑分账' : '新建分账',
    itemSpan: 24,
    // debug: true,

    formAttrs: {
      disabled: isView
    },

    formItemsAttrs: {},

    onShow: async ({ data, app }: PageContext) => {
      let payload = { ...data }

      console.log('处理后的 payload:', payload)
      console.log('原始 receivers:', payload.receivers)

      // 确保 receivers 是数组
      if (!payload.receivers) {
        payload.receivers = []
      }

      // 转换收款方数据格式：将后端的 USER 转换为前端组件使用的 MERCHANT
      if (payload.receivers && payload.receivers.length > 0) {
        payload.receivers = payload.receivers.map((receiver: any) => {
          const converted = {
            ...receiver,
            // 反向转换：USER -> MERCHANT（前端组件使用 MERCHANT 表示手机号直分）
            splitType: receiver.splitType === 'USER' ? 'MERCHANT' : receiver.splitType,
            // 确保必要字段存在
            receiverDesc: receiver.receiverDesc || '',
            receiverAccount: receiver.receiverAccount || '',
            splitRatio: receiver.splitRatio || 0
          }
          console.log('单个收款方转换:', receiver, '->', converted)
          return converted
        })
        console.log('转换后的收款方数据:', payload.receivers)
      }
      const expireTime = new Date(payload.expireTime)
      const currentTime = new Date()
      // 创建一个表示50年后的时间
      const fiftyYearsLater = new Date()
      fiftyYearsLater.setFullYear(fiftyYearsLater.getFullYear() + 50)

      // 比较 expireTime 是否大于50年后的时间
      const isMoreThan50Years = expireTime > fiftyYearsLater

      // 如果你想知道 expireTime 是否在50年内（即小于50年后）
      const isWithin50Years = expireTime <= fiftyYearsLater && expireTime > currentTime

      if (!isWithin50Years) {
        payload.expireTime = ''
      }

      payload.originEffectiveTime = payload.effectiveTime
      payload.isView = isView

      return { payload }
    },
    //
    beforeSubmit: async ({ data }: PageContext, model: any, options: any) => {
      // const currentTime = new Date()
      // const selectedTime = new Date(data.effectiveTime)
      // // 计算10分钟后的时间
      // const minTime = new Date(currentTime.getTime() + 10 * 60 * 1000)
      // // 计算30天后的时间
      // const maxTime = new Date(currentTime.getTime() + 30 * 24 * 60 * 60 * 1000)
      // // 判断时间范围
      // if (selectedTime < minTime) {
      //   // 使用你项目中的提示组件，这里用示例代码
      //   ElMessage.success('分账开始时间必须晚于当前时间10分钟')
      //
      //   // 或者重置时间
      //   data.effectiveTime = null
      //   return false
      // } else if (selectedTime > maxTime) {
      //   ElMessage.success('分账开始时间不能晚于当前时间30天')
      //   // 或者重置时间
      //   data.effectiveTime = null
      //   return false
      // }

      if (isAdd) {
        data.originEffectiveTime = data.effectiveTime
      }
      const valite = validateFormat(data.effectiveTime, data.expireTime, isEdit, data.originEffectiveTime)
      if (!valite) {
        return false
      }

      // 日期格式转换函数：将 ISO 格式转换为 yyyy-MM-dd HH:mm:ss
      const formatDateTime = (dateTime: any) => {
        if (!dateTime) return undefined

        const date = new Date(dateTime)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        const seconds = String(date.getSeconds()).padStart(2, '0')

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      }

      // 转换收款方数据
      const receivers = (model.value.receivers || []).map((receiver: any, index: number) => {
        return {
          receiverOrder: index + 1,
          splitMode: 'RATIO', // 统一使用比例模式
          splitRatio: receiver.splitRatio,
          splitType: receiver.splitType === 'MERCHANT' ? 'USER' : receiver.splitType, // MERCHANT 转换为 USER
          receiverAccount: receiver.receiverAccount,
          receiverName: receiver.receiverName,
          receiverDesc: receiver.receiverDesc || ''
        }
      })

      // 构建提交数据
      const payload: any = {
        vehicleSn: model.value.vehicleSn,
        isDirectInvestment: model.value.isDirectInvestment,
        receivers: receivers
      }

      // 编辑时需要传递 ruleId
      if (isEdit) {
        payload.ruleId = data.id || model.value.id
        console.log('编辑模式，添加 ruleId:', payload.ruleId)
      } else {
        // 新增时自动生成规则名称
        payload.ruleName = `分账规则_${model.value.vehicleSn || Date.now()}`
      }

      // 可选字段（需要格式化日期）
      if (model.value.deliveryUnitPrice) {
        payload.deliveryUnitPrice = model.value.deliveryUnitPrice
      }
      if (model.value.effectiveTime) {
        payload.effectiveTime = formatDateTime(model.value.effectiveTime)
        console.log('分账开始时间格式化:', model.value.effectiveTime, '->', payload.effectiveTime)
      }
      if (model.value.expireTime) {
        payload.expireTime = formatDateTime(model.value.expireTime)
        console.log('分账结束时间格式化:', model.value.expireTime, '->', payload.expireTime)
      }

      console.log('✅ 最终提交数据:', JSON.stringify(payload, null, 2))
      return payload
    },
    afterSubmit: async ({ data, app }: PageContext, model: any, options: any) => {
      window.location.reload(true)
    },

    formItems: [
      { label: '无人车SN', type: 'input', prop: 'vehicleSn', required: true },
      {
        label: '是否直投',
        type: 'checkbox',
        span: 23,
        checkType: 'radio',
        prop: 'isDirectInvestment',
        required: true,
        options: [
          { label: '是', value: 1 },
          { label: '否', value: 0 }
        ]
      },
      {
        label: '配送单价（元）',
        type: 'input-number',
        prop: 'deliveryUnitPrice',
        min: 0.1,
        max: 999,
        default: 0,
        precision: 2,
        span: 11
      },
      {
        labelWidth: 0,
        type: 'html',
        html: '<span class="text-red">最低0.1，最高999，支持2位小数</span>',
        span: 13
      },

      {
        label: '收款方',
        type: 'payment-collection',
        autoHeight: true,
        prop: 'receivers',
        labelProp: 'receivers',
        span: 24,
        dynamicAttrs: ({ data }: PageContext) => {
          const hidden = data.applicableProductType === 'all'
          return { hidden, required: !hidden }
        }
      },

      {
        label: '分账开始时间',
        type: 'date-picker',
        prop: 'effectiveTime',
        pickerType: 'datetime',
        format: 'YYYY-MM-DD HH:mm:ss',
        valueFormat: 'YYYY-MM-DD HH:mm:ss',
        afterToday: true,
        span: 15,
        disabled: isEdit,
        beforeDate: 'T+30d',
        afterDate: 'T+0d',
        itemAttrs: formItemStyleAttrs,
        dynamicAttrs: ({ data }: PageContext) => {
          const timeStatus = getTimeStatus(data.originEffectiveTime, data.expireTime)

          const visible = true
          return {
            hidden: !visible,
            required: visible,
            disabled:
              isView || (['IN_PROGRESS', 'APPROACHING_END'].includes(timeStatus) && dialogType !== DialogType.ADD)
          }
        }
      },
      {
        labelWidth: 0,
        type: 'html',
        html: '<span class="text-red">需大于当前时间10分钟,小于当前时间+30天</span>',
        span: 9
      },

      {
        label: '分账结束时间',
        type: 'date-picker',
        prop: 'expireTime',
        pickerType: 'datetime',
        format: 'YYYY-MM-DD HH:mm:ss',
        valueFormat: 'YYYY-MM-DD HH:mm:ss',
        afterToday: true,
        disabled: isEdit,
        beforeDate: 'T+30d',
        afterDate: 'T+0d',
        itemAttrs: formItemStyleAttrs,
        onChange: async (model: any, val: any) => {
          if (!model.expireTime) return
        },
        dynamicAttrs: ({ data }: PageContext) => {
          const visible = true
          return { hidden: !visible, required: false, disabled: isView || (isEdit && data.activityStatus === 1) }
        }
      }
    ]
  }
}

export function dowanLoadFile() {
  return {
    message: false,
    api: 'none',
    onAction: async ({ app, data }: PageContext) => {
      let list: any[] = []
      let sheetData: any[] = []
      let isStop = false
      let pageIndex = 1
      while (!isStop) {
        const res = await app.request({
          api: '/sys/admin/order/share/rule/getSettleDetail',
          params: {
            ruleId: data.id,
            pageIndex: pageIndex,
            pageSize: 10
          }
        })

        const { detailInfoList } = res
        if (detailInfoList.length === 0) {
          isStop = true
          break
        }

        list = list.concat(detailInfoList)
        pageIndex++
      }

      console.log(list.length)
      if (list.length > 0) {
        sheetData = list.map((item: any) => {
          const statusJSON: any = {
            PENDING: '待结算',
            SETTLING: '结算中',
            SETTLED: '已结算',
            FAILED: '结算失败'
          }

          return {
            设备号: item.snNo || '',
            订单号: item.orderId || '',
            订单送达时间: item.orderFinishTime ? dayjs(item.orderFinishTime).format('YYYY-MM-DD HH:mm:ss') || '' : '',
            单价: item.unitPrice || '',
            分账比例: item.settleRito || '',
            结算类型: item.settleType === 'ONLY_NUM' ? '仅作记录' : '手机号分佣',
            姓名: item.userName || '',
            '手机号/id': item.userPhone || '',
            分账状态: statusJSON[item.splitStatus],
            分账结束时间: item.finishTime ? dayjs(item.finishTime).format('YYYY-MM-DD HH:mm:ss') || '' : '',
            分账金额: item.amount || ''
          }
        })
      }

      // 使用xlsx.js 生成excel并下载
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet(sheetData)
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
      XLSX.writeFile(wb, `1688_${Date.now()}.xlsx`)
      app.ui.showMessage({
        type: 'success',
        message: `下载成功！`
      })
      return false
    }
  }
}
